<template>
  <b-row>
    <b-col :sm="12">
      <h3>{{ $t("ITEMS") }}:</h3>
    </b-col>
    <b-col lg="3">
      <v-text-field
        :disabled="true"
        v-model="supplierName"
        :label="$t('SUPPLIER')"
        hide-details
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        v-model="tempGlobalSupplierDoc.num"
        :label="$t('DOC_NUM')"
        hide-details
        type="number"
        step="1"
        min="0"
      ></v-text-field>
    </b-col>
    <b-col>
      <FormDatepickerBase
        :type="'text'"
        :i18n="{
          label: 'DOC_DATE',
          placeholder: $t('DOC_DATE')
        }"
        :date.sync="tempGlobalSupplierDoc.date"
      ></FormDatepickerBase>
    </b-col>
    <b-col>
      <v-text-field
        :disabled="true"
        v-model="tempGlobalSupplierDoc.totalCurrency"
        :label="$t('TOTAL_PRICE')"
        hide-details
        type="number"
        step="1"
        min="0"
      ></v-text-field>
    </b-col>
    <b-col lg="1">
      <v-select
        hide-details
        :items="currencies"
        item-text="code"
        item-value="id"
        :label="$t('CURRENCY')"
        v-model="tempGlobalSupplierDoc.currencyId"
      ></v-select>
    </b-col>
    <b-col lg="1">
      <v-select
        hide-details
        :items="vatGroups"
        item-text="name"
        item-value="id"
        :label="$t('VAT_GROUPS')"
        v-model="tempGlobalSupplierDoc.vatGroupId"
      ></v-select>
    </b-col>
  </b-row>
</template>
<script>
import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";
import _ from "lodash";
export default {
  name: "SetSupplierDoc",
  inheritAttrs: false,
  props: {
    firstLoader: {
      type: Boolean,
      default: true
    },
    supplierName: {
      type: String,
      default: function() {
        return "";
      }
    },
    stockActionTypeId: {
      type: Number,
      default: 1
    },
    vatGroups: {
      type: Array,
      default: function() {
        return [];
      }
    },
    currencies: {
      type: Array,
      default: function() {
        return [];
      }
    },
    globalSupplierDoc: {
      type: Object,
      default: function() {
        return {
          visible: false,
          num: "",
          date: "",
          vatGroupId: 3,
          currencyId: 1,
          totalCurrency: "0.00"
        };
      }
    }
  },
  data() {
    return {};
  },
  components: { FormDatepickerBase },
  mounted() {},
  computed: {
    tempFirstLoader: {
      get: function() {
        return this.firstLoader;
      },
      set: function(newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    tempGlobalSupplierDoc: {
      get: function() {
        return this.globalSupplierDoc;
      },
      set: function(newValue) {
        this.$emit("update:globalSupplierDoc", newValue);
      }
    }
  },
  watch: {},
  methods: {}
};
</script>
